import Icon from '../components/Icon.vue'

Icon.register({
  'hat-wizard': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480zM192 384l16 32h-144l111-249.7c9.4-21.2 33.4-47.7 53.5-59.1l187.6-107.2-56.3 168.9c-1.8 5.4-3.3 14.5-3.3 20.2 0 7.3 2.3 18.5 5.2 25.2l86.4 201.6h-208l16-32 64-32-64-32-32-64-32 64-64 32zM256 160l-32 16 32 16 16 32 16-32 32-16-32-16-16-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hat-wizard.js
// module id = 1445
// module chunks = 0